// Browser-locale detection for the app's tri-locale surfaces.
//
// Extracted from checkoutStore.ts (Phase 2 — it was duplicated verbatim in
// three places). The app has no user language field (D7): the outbound package
// language defaults from the browser and is then overridable per tender.
export type AppLocale = 'en' | 'nl' | 'fr';

export function detectLocale(): AppLocale {
  if (typeof navigator === 'undefined') {
    return 'en';
  }
  const primary = (navigator.language || 'en').slice(0, 2).toLowerCase();
  if (primary === 'nl' || primary === 'fr') {
    return primary;
  }
  return 'en';
}
